import ReactOnRails from 'react-on-rails';

import HelloWorld from '../bundles/HelloWorld/components/HelloWorld';

ReactOnRails.register({
  HelloWorld,
});
